import React, { useState } from "react";
import CrmEmpty from "./CrmEmpty";
import { Row, Col, Table, Spin, Space, Button, Modal, Descriptions } from "antd";
import strings from '../../../utils/strings';
import moment from 'moment-jalaali';
import { ZoomInOutlined } from '@ant-design/icons';
import { useReportsStore } from "../../../store/slices/createReportsSlice";

export default function CrmUserReceipt() {

  const reports = useReportsStore()
  const data = reports.crmUserReceipt.data.Receipts;
  const loading = reports.crmUserReceipt.loading;
  const details = reports.userReceiptDetails.data.Details;
  const detailsLoading = reports.userReceiptDetails.loading;
  const [Id, setId] = useState();
  const [visible, setVisible] = useState(false);


  const columns = [
    {
      title: "جزئیات",
      dataIndex: "operation",
      key: "operation",
      width: 40,
      render: (_, record) =>
        data.length >= 1 && (
          <Space size="middle">
            <Button type='link' onClick={() => {
              reports.getUserReceiptDetails(record.Id);
              setId(record.Id);
              setVisible(true);
            }
            }><ZoomInOutlined /></Button>
          </Space>
        ),
    },

    {
      title: " نوع رسید",
      dataIndex: "ReceiptType",
      key: "ReceiptType",
      width: 100,
      render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
    },
    {
      title: "نام بیزینس",
      dataIndex: "BusinessName",
      key: "BusinessName",
      width: 100,
      sorter: (a, b) => {
        let first = "";
        let second = "";
        a.BusinessName ? (first = a.BusinessName) : (first = "");
        b.BusinessName ? (second = b.BusinessName) : (second = "");
        return first.localeCompare(second);
      },

      render: text => text && strings.getFarsiNum(text),
    },

    {
      title: "کد رهگیری",
      dataIndex: "TrackingCode",
      key: "TrackingCode",
      width: 115,

      render: text => text && text.toUpperCase().replace('BM-', '')
    },

    {
      title: "وضعيت درخواست",
      dataIndex: "StatusTitle",
      key: "StatusTitle",
      width: 110,
      sorter: (a, b) => {
        let first = "";
        let second = "";
        a.StatusTitle ? (first = a.StatusTitle) : (first = "");
        b.StatusTitle ? (second = b.StatusTitle) : (second = "");
        return first.localeCompare(second);
      },

    },
    {
      title: 'تاریخ درخواست',
      dataIndex: 'CreationTime',
      key: 'CreationTime',
      width: 110,
      render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD  ساعت:  HH:mm'))
  },
    {
      title: 'مبلغ(ریال)',
      dataIndex: 'Amount',
      key: 'Amount',
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
  ];


  return (
    <Spin spinning={loading} >
      {data && data.length > 0 ? <>
        <Table
          style={{ overflowX: 'scroll' }}
          size="small"
          className="custom-table crm-request-report"
          bordered
          loading={loading}
          rowKey="ID"
          scroll={true}
          dataSource={data}
          columns={columns}
        />
        <Modal
          width={900}
          title="جزئیات رسید"
          className="custom-table"
          visible={visible}
          footer={false}
          onCancel={() => setVisible(false)}>
          <Spin spinning={detailsLoading}>
            <Row>
              {details && details?.length ? details?.map((item, index) => {
                return <Col span={8}>
                  <Descriptions key={index}>
                    <Descriptions.Item label={item.Title} className="font-bold">
                      {item.Value}
                    </Descriptions.Item>
                  </Descriptions>
                </Col>
              }) :
                <CrmEmpty text="یافت نشد" />}
            </Row>
          </Spin>
        </Modal>
      </>
        :
        <CrmEmpty text="رسید کاربر یافت نشد" />}
    </Spin>
  );
}
